import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import {
  ArrowRight,
  BriefcaseBusiness,
  Building2,
  ChartColumnBig,
  GraduationCap,
  HeartPulse,
  Landmark,
  Leaf,
  LineChart,
  Map,
  MoveRight,
  ShieldCheck,
  Sprout,
  Users,
} from "lucide-react";

const categoryCards = [
  {
    title: "Economic",
    eyebrow: "Economic Snapshot",
    icon: ChartColumnBig,
    mapImage: "/img/utah-map.png",
    points: [
      "Employment and wage trends",
      "Industry and business activity",
      "Taxes, finance, and markets",
      "Utah economic verticals",
    ],
    links: [
      { label: "Utah Employment", path: "/utah-at-a-glance/utah-employment" },
      {
        label: "In-Demand Jobs",
        path: "/utah-at-a-glance/in-demand-jobs-and-wages",
      },
      {
        label: "Unemployment Rate",
        path: "/utah-at-a-glance/unemployment-rate",
      },
      { label: "Utah Taxes", path: "/utah-at-a-glance/taxes" },
      {
        label: "Financial Institutions",
        path: "/utah-at-a-glance/financial-institutions",
      },
      { label: "MLM", path: "/utah-at-a-glance/mlm" },
    ],
  },
  {
    title: "Demographic",
    eyebrow: "People & Trends",
    icon: Users,
    mapImage: "/img/utah-map.png",
    points: [
      "Population and migration",
      "Age, households, and diversity",
      "Utah cities and communities",
      "Resident trend snapshots",
    ],
    links: [
      { label: "Demographics", path: "/utah-at-a-glance/demographics" },
      { label: "Utah Cities", path: "/utah-at-a-glance/utah-cities" },
      { label: "Utah History", path: "/utah-at-a-glance/utah-history" },
      { label: "Utah Voters Count", path: "/utah-at-a-glance/utah-voters-count" },
    ],
  },
  {
    title: "Counties",
    eyebrow: "County Explorer",
    icon: Map,
    mapImage: "/img/utahcountymap.png",
    points: [
      "County profiles & comparisons",
      "Local trends and place data",
      "Zip codes and regional context",
      "Utah at a Glance views",
    ],
    links: [
      { label: "Utah Counties", path: "/utah-at-a-glance/utah-counties" },
      { label: "Utah County", path: "/utah-at-a-glance/utah-counties/utah-county" },
      { label: "Utah Zipcodes", path: "/utah-at-a-glance/zipcodes" },
      { label: "Utah Cities", path: "/utah-at-a-glance/utah-cities" },
    ],
  },
  {
    title: "Education",
    eyebrow: "Learning & Schools",
    icon: GraduationCap,
    mapImage: "/img/utah-map.png",
    points: [
      "Schools, universities, and districts",
      "Student and learning resources",
      "Training and workforce pathways",
      "Education access across Utah",
    ],
    links: [
      {
        label: "Education Resources",
        path: "/utah-at-a-glance/universities-and-schools",
      },
      {
        label: "Utah Universities",
        path: "/utah-at-a-glance/universities-and-schools/utah-universities",
      },
      {
        label: "Utah Schools",
        path: "/utah-at-a-glance/universities-and-schools/utah-schools",
      },
      {
        label: "Charter Schools",
        path: "/utah-at-a-glance/universities-and-schools/utah-schools/charter-schools",
      },
    ],
  },
  {
    title: "Health & Housing",
    eyebrow: "Health & Living",
    icon: HeartPulse,
    mapImage: "/img/utah-map.png",
    points: [
      "Hospitals and health access",
      "Housing trends and affordability",
      "Community well-being signals",
      "Local living conditions",
    ],
    links: [
      { label: "Utah Hospitals", path: "/utah-at-a-glance/hospitals" },
      { label: "Utah Housing", path: "/utah-at-a-glance/housing" },
      { label: "Air Quality", path: "/utah-at-a-glance/air-quality-index" },
      { label: "Autism & DD", path: "/utah-at-a-glance/autism-dd" },
      {
        label: "Utah Nonprofits",
        path: "/utah-at-a-glance/utah-nonprofits",
      },
    ],
  },
  {
    title: "Government & Civic",
    eyebrow: "Policy & Public Life",
    icon: Landmark,
    mapImage: "/img/utah-map.png",
    points: [
      "Leadership and public policy",
      "Budget and legislative activity",
      "Federal and nonprofit directories",
      "Voter and civic participation data",
    ],
    links: [
      { label: "Utah Governor", path: "/utah-at-a-glance/utah-governor" },
      { label: "Utah Budget", path: "/utah-at-a-glance/utah-budget" },
      { label: "Utah Legislature", path: "/utah-at-a-glance/utah-legislature" },
      { label: "Federal Agencies", path: "/utah-at-a-glance/federal-agencies" },
      {
        label: "Nonprofit Data Insights",
        path: "/utah-at-a-glance/utah-nonprofits/nonprofit-data-insights",
      },
      {
        label: "Utah Voters Count",
        path: "/utah-at-a-glance/utah-voters-count",
      },
    ],
  },
  {
    title: "Infrastructure & Resources",
    eyebrow: "Systems & Access",
    icon: Building2,
    mapImage: "/img/utah-map.png",
    points: [
      "Transportation and mobility assets",
      "Energy systems and utilities",
      "Water, construction, and facilities",
      "Statewide infrastructure access points",
    ],
    links: [
      { label: "Utah Water", path: "/utah-at-a-glance/utah-water" },
      { label: "Utah Airports", path: "/utah-at-a-glance/utah-airports" },
      {
        label: "Charging Stations",
        path: "/utah-at-a-glance/charging-stations",
      },
      {
        label: "Operation Gigawatt",
        path: "/utah-at-a-glance/utah-operation-gigawatt",
      },
      {
        label: "Construction Intelligence",
        path: "/utah-at-a-glance/construction-intelligence",
      },
      {
        label: "Utah Libraries",
        path: "/utah-at-a-glance/utah-libraries",
      },
    ],
  },
  {
    title: "Environment & Places",
    eyebrow: "Land & Environment",
    icon: Leaf,
    mapImage: "/img/utah-map.png",
    points: [
      "Air, water, land, and energy",
      "Parks, tourism, and recreation",
      "Natural resources and geography",
      "Utah places to visit",
    ],
    links: [
      { label: "Utah Water", path: "/utah-at-a-glance/utah-water" },
      { label: "Utah Land", path: "/utah-at-a-glance/utah-land" },
      {
        label: "Geothermal Hotspots",
        path: "/utah-at-a-glance/utah-geothermal-hotspots",
      },
      {
        label: "Places to Visit",
        path: "/utah-at-a-glance/utah-places-to-visit",
      },
      {
        label: "Utah Mines",
        path: "/utah-at-a-glance/utah-mines",
      },
    ],
  },
  {
    title: "Culture & Recreation",
    eyebrow: "Culture & Travel",
    icon: Sprout,
    mapImage: "/img/utah-map.png",
    points: [
      "History, sports, and adventure",
      "Tourism and recreation discovery",
      "Culture and place-based storytelling",
      "Leisure-focused Utah insights",
    ],
    links: [
      { label: "Utah History", path: "/utah-at-a-glance/utah-history" },
      { label: "Adventure Activities", path: "/utah-at-a-glance/adventure-activities" },
      { label: "Sports Club", path: "/utah-at-a-glance/sports-club" },
      {
        label: "Places to Visit",
        path: "/utah-at-a-glance/utah-places-to-visit",
      },
    ],
  },
];

const userCards = [
  {
    title: "Economists",
    icon: LineChart,
    description: "Track labor, growth, industry, and market signals.",
    startLabel: "Start with Economic pages",
    startPath: "/utah-at-a-glance/in-demand-jobs-and-wages",
  },
  {
    title: "Policymakers",
    icon: Landmark,
    description: "Compare regions and support planning with evidence.",
    startLabel: "Start with County insights",
    startPath: "/utah-at-a-glance/utah-counties",
  },
  {
    title: "Educators",
    icon: GraduationCap,
    description: "Bring Utah-focused data into lessons, programs, and research.",
    startLabel: "Start with Education resources",
    startPath: "/utah-at-a-glance/universities-and-schools",
  },
  {
    title: "Businesses",
    icon: Building2,
    description: "See market context before expanding or investing.",
    startLabel: "Start with Utah Employment",
    startPath: "/utah-at-a-glance/utah-employment",
  },
  {
    title: "Tourists",
    icon: Map,
    description: "Explore Utah through practical, place-based insights.",
    startLabel: "Start with Places to Visit",
    startPath: "/utah-at-a-glance/utah-places-to-visit",
  },
  {
    title: "Industry Professionals",
    icon: BriefcaseBusiness,
    description: "Find targeted data that supports planning and strategy.",
    startLabel: "Start with Utah At a Glance",
    startPath: "/utah-at-a-glance",
  },
];

const surfaceCard =
  "rounded-[28px] border border-[#d9e2e8] bg-white/92 shadow-[0_18px_50px_rgba(15,23,42,0.06)] backdrop-blur";

const categoryThemes = [
  {
    shell: "bg-[linear-gradient(180deg,#ffffff_0%,#f4f9fc_100%)]",
    accent: "bg-[#153f63]",
    icon: "bg-white text-[#153f63] shadow-[0_10px_25px_rgba(21,63,99,0.10)]",
    dot: "bg-[#c97712]",
    glow: "bg-[radial-gradient(circle_at_top_right,rgba(21,63,99,0.10),transparent_46%)]",
    link: "bg-[#fbfdfe]",
  },
  {
    shell: "bg-[linear-gradient(180deg,#fffefb_0%,#f4f8f1_100%)]",
    accent: "bg-[#355d43]",
    icon: "bg-white text-[#355d43] shadow-[0_10px_25px_rgba(53,93,67,0.10)]",
    dot: "bg-[#628d19]",
    glow: "bg-[radial-gradient(circle_at_top_right,rgba(53,93,67,0.10),transparent_46%)]",
    link: "bg-[#fbfdf9]",
  },
  {
    shell: "bg-[linear-gradient(180deg,#fffdf9_0%,#fbf3e7_100%)]",
    accent: "bg-[#9b6416]",
    icon: "bg-white text-[#9b6416] shadow-[0_10px_25px_rgba(155,100,22,0.10)]",
    dot: "bg-[#cf7c1e]",
    glow: "bg-[radial-gradient(circle_at_top_right,rgba(155,100,22,0.10),transparent_46%)]",
    link: "bg-[#fffcf8]",
  },
];

export default function UtahDataCategoriesUsers() {
  return (
    <div className="min-h-screen bg-[#f7f4ed] text-slate-900">
      <Header />

      <main className="relative overflow-hidden">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-[0.08]"
          style={{
            backgroundImage: 'url("/img/verticals/verticals_section_bg.webp")',
            backgroundRepeat: "repeat",
            backgroundPosition: "top left",
          }}
        />
        <div className="pointer-events-none absolute inset-x-0 top-0 h-[32rem] bg-[radial-gradient(circle_at_top_left,_rgba(21,63,99,0.08),_transparent_42%),radial-gradient(circle_at_top_right,_rgba(207,124,30,0.08),_transparent_36%)]" />

        <section className="relative px-4 pb-16 pt-32 sm:px-6 sm:pb-20 sm:pt-40 lg:px-8">
          <div className="pointer-events-none absolute inset-0 overflow-hidden">
            <img
              src="/img/landing-webp/close-up-magnifying-glass-map.webp"
              alt=""
              aria-hidden="true"
              className="absolute right-[-6rem] top-[-2rem] hidden h-[32rem] w-[32rem] rounded-full object-cover opacity-[0.3] blur-[0.5px] lg:block"
            />
            <img
              src="/img/utah-map.png"
              alt=""
              aria-hidden="true"
              className="absolute left-[-5rem] top-[4rem] hidden h-[26rem] w-[26rem] rotate-[-10deg] object-contain opacity-[0.08] saturate-0 md:block"
            />
            <div className="absolute right-[12%] top-[18%] hidden h-64 w-64 rounded-full bg-[#efd1a0]/24 blur-3xl lg:block" />
          </div>

          <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[minmax(0,1fr)_22rem] lg:items-end">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-[#d7e0e6] bg-white/88 px-4 py-2 text-xs font-semibold uppercase tracking-[0.24em] text-[#153f63] shadow-sm">
                <img
                  src="/img/utahdata_logo_new.png"
                  alt="UtahData"
                  className="h-4 w-4 rounded-full object-contain"
                />
                UtahData
              </div>

              <h1 className="mt-6 max-w-3xl text-4xl font-semibold tracking-[-0.04em] text-[#123a59] sm:text-5xl lg:text-6xl">
                What Data We Have.
                <br />
                Who Can Use It.
              </h1>

              <p className="mt-5 max-w-2xl text-base leading-7 text-[#334a5f] sm:text-lg">
                A quick overview of the kinds of data available on
                UtahData.org, from economic and demographic insights to
                county-level, education, health, housing, and tourism data.
              </p>

              <div className="mt-6 flex flex-wrap gap-2">
                {categoryCards.map((category) => (
                  <a
                    key={category.title}
                    href={`#${category.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className="rounded-full border border-[#d7e0e6] bg-white/86 px-4 py-2 text-xs font-semibold uppercase tracking-[0.18em] text-[#153f63] no-underline transition hover:border-[#c2cfd9] hover:bg-white"
                  >
                    {category.title}
                  </a>
                ))}
              </div>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <a
                  href="#categories"
                  className="inline-flex items-center justify-center gap-2 rounded-full bg-[#153f63] px-6 py-3 text-sm font-semibold text-white no-underline transition hover:bg-[#102f4a]"
                >
                  Explore Categories
                  <ArrowRight className="h-4 w-4" />
                </a>
                <Link
                  to="/utah-at-a-glance"
                  className="inline-flex items-center justify-center gap-2 rounded-full border border-[#d7e0e6] bg-white/92 px-6 py-3 text-sm font-semibold text-[#153f63] no-underline transition hover:border-[#c2cfd9] hover:bg-white"
                >
                  Open Utah At a Glance
                </Link>
              </div>
            </div>

            <div className={`${surfaceCard} p-6 sm:p-7`}>
              <div className="grid gap-4">
                <div className="rounded-3xl bg-[#123a59] px-5 py-4 text-white shadow-[0_10px_30px_rgba(18,58,89,0.14)] min-h-[7.2rem]">
                  <div className="flex min-h-[4.8rem] items-center gap-4">
                    <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white/10 text-5xl font-semibold tracking-[-0.05em] text-white">
                      9
                    </div>
                    <div className="flex min-h-[4.8rem] flex-1 flex-col justify-center">
                      <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-white/65">
                        Overview
                      </p>
                      <p className="mb-0 text-base font-semibold text-white">
                        Data categories
                      </p>
                    </div>
                  </div>
                </div>

                <div className="rounded-3xl bg-[#dceaf4] px-5 py-4 text-[#123a59] min-h-[7.2rem]">
                  <div className="flex min-h-[4.8rem] items-center gap-4">
                    <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white/60 text-5xl font-semibold tracking-[-0.05em] text-[#123a59]">
                      6
                    </div>
                    <div className="flex min-h-[4.8rem] flex-1 flex-col justify-center">
                      <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#31546e]">
                        Audience
                      </p>
                      <p className="mb-0 text-base font-semibold text-[#123a59]">
                        Target user groups
                      </p>
                    </div>
                  </div>
                </div>

                <div className="rounded-3xl bg-[#f5e7ca] px-5 py-4 text-[#7a5314] min-h-[7.2rem]">
                  <div className="flex min-h-[4.8rem] items-center gap-4">
                    <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-white/55 text-[#9b6416]">
                      <ShieldCheck className="h-9 w-9" />
                    </div>
                    <div className="flex min-h-[4.8rem] flex-1 flex-col justify-center">
                      <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.2em] text-[#9b6416]">
                        Purpose
                      </p>
                      <p className="mb-0 text-base font-semibold leading-6 text-[#7a5314]">
                        Shows data variety and audience fit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="categories" className="px-4 py-8 sm:px-6 sm:py-10 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <div className="mb-8 flex flex-col gap-3 sm:mb-10 sm:flex-row sm:items-end sm:justify-between">
              <div>
                <p className="text-sm font-semibold uppercase tracking-[0.24em] text-[#9b6416]">
                  Data Categories
                </p>
                <h2 className="mt-2 text-3xl font-semibold tracking-[-0.04em] text-[#123a59] sm:text-4xl">
                  What kinds of data are on the site
                </h2>
              </div>
              <p className="max-w-xl text-sm leading-6 text-[#55697b] sm:text-base">
                These cards summarize the main varieties of data people can
                browse across UtahData.org.
              </p>
            </div>

            <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
              {categoryCards.map(({ title, eyebrow, icon: Icon, points, links, mapImage }, index) => {
                const theme = categoryThemes[index % categoryThemes.length];

                return (
                <article
                  key={title}
                  id={title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}
                  className={`group flex h-full flex-col overflow-hidden rounded-[30px] border border-[#d9e2e8] shadow-[0_16px_48px_rgba(15,23,42,0.06)] transition duration-300 hover:-translate-y-1 hover:shadow-[0_24px_70px_rgba(15,23,42,0.10)] ${theme.shell} scroll-mt-36`}
                >
                  <div className="relative flex flex-1 flex-col overflow-hidden px-6 pb-6 pt-6">
                    <div className={`absolute inset-x-0 top-0 h-2 ${theme.accent}`} />
                    <div className={`pointer-events-none absolute inset-0 ${theme.glow}`} />
                    <img
                      src={mapImage}
                      alt=""
                      aria-hidden="true"
                      className="pointer-events-none absolute -right-10 top-10 h-40 w-40 rotate-[10deg] object-contain opacity-[0.11] saturate-0"
                    />
                    <div className="pointer-events-none absolute -bottom-12 -right-6 h-28 w-28 rounded-full bg-white/35 blur-2xl" />
                    <div className="flex items-start gap-4">
                        <div className={`mt-1 rounded-[20px] p-4 ${theme.icon}`}>
                          <Icon className="h-6 w-6" />
                        </div>
                        <div>
                          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-[#5f7384]">
                            {eyebrow}
                          </p>
                          <h3 className="mb-0 text-[1.75rem] font-semibold leading-[1.05] tracking-[-0.04em] text-[#123a59]">
                            {title}
                          </h3>
                        </div>
                    </div>

                    <div className="mt-5 inline-flex w-fit rounded-full border border-[#dbe4ea] bg-white/92 px-3 py-1 text-[11px] font-semibold text-[#647887] shadow-sm">
                      Utah at a Glance
                    </div>

                    <ul className="mb-0 mt-5 flex-1 space-y-3 pl-0">
                      {points.map((point) => (
                        <li
                          key={point}
                          className="flex items-start gap-3 text-sm leading-6 text-[#334a5f] sm:text-[15px]"
                        >
                          <span className={`mt-2 h-2 w-2 shrink-0 rounded-full ${theme.dot}`} />
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="mx-4 mb-4 mt-auto flex h-[21rem] flex-col pt-4">
                    <div className="mb-3 text-left">
                      <p className="mb-0 text-left text-xs font-semibold uppercase tracking-[0.18em] text-[#9b6416]">
                        Quick Links
                      </p>
                    </div>
                    <div className="grid w-full gap-2">
                      {links.map((linkItem) => (
                        <Link
                          key={linkItem.path}
                          to={linkItem.path}
                          className={`box-border flex w-full max-w-full items-center justify-between gap-3 rounded-full border border-[#d3dde4] px-4 py-2 text-left text-sm font-medium text-[#153f63] no-underline transition hover:border-[#bcc9d3] hover:bg-white ${theme.link}`}
                        >
                          <span className="min-w-0 flex-1 truncate whitespace-nowrap text-left">
                            {linkItem.label}
                          </span>
                          <MoveRight className="h-4 w-4 shrink-0" />
                        </Link>
                      ))}
                    </div>
                  </div>
                </article>
                );
              })}
            </div>
          </div>
        </section>

        <section className="px-4 py-8 sm:px-6 sm:py-10 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <div className="mb-8">
              <p className="text-sm font-semibold uppercase tracking-[0.24em] text-[#9b6416]">
                Target Users
              </p>
              <h2 className="mt-2 text-3xl font-semibold tracking-[-0.04em] text-[#123a59] sm:text-4xl">
                Who could use this data
              </h2>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 xl:grid-cols-3">
              {userCards.map(
                ({ title, icon: Icon, description, startLabel, startPath }) => (
                <article
                  key={title}
                  className={`${surfaceCard} flex h-full items-start gap-4 p-6`}
                >
                  <div className="rounded-2xl bg-[#153f63] p-3 text-white shadow-[0_10px_24px_rgba(21,63,99,0.14)]">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div className="flex min-h-[150px] flex-1 flex-col">
                    <h3 className="mb-2 text-lg font-semibold text-[#123a59]">
                      {title}
                    </h3>
                    <p className="mb-0 flex-1 text-sm leading-6 text-[#55697b]">
                      {description}
                    </p>
                    <Link
                      to={startPath}
                      className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#153f63] no-underline"
                    >
                      {startLabel}
                      <MoveRight className="h-4 w-4" />
                    </Link>
                  </div>
                </article>
                ),
              )}
            </div>
          </div>
        </section>

        <section className="px-4 pb-20 pt-8 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <div className="overflow-hidden rounded-[32px] bg-[#123a59] px-6 py-8 text-white shadow-[0_22px_70px_rgba(18,58,89,0.22)] sm:px-8 sm:py-10 lg:px-10">
              <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
                <div className="max-w-2xl">
                  <p className="text-sm font-semibold uppercase tracking-[0.24em] text-[#f3d9a6]">
                    Call To Action
                  </p>
                  <h2 className="mt-2 text-3xl font-semibold tracking-[-0.04em] sm:text-4xl">
                    Move from overview to insight
                  </h2>
                  <p className="mb-0 mt-3 text-sm leading-6 text-slate-200 sm:text-base">
                    Visit UtahData.org and jump into the right Utah at a Glance
                    page faster.
                  </p>
                </div>

                <div className="flex flex-col gap-3 sm:flex-row lg:shrink-0">
                  <Link
                    to="/utah-at-a-glance"
                    className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-[#082f49] no-underline transition hover:bg-[#f8fafc]"
                  >
                    Utah At a Glance
                  </Link>
                  <Link
                    to="/utah-at-a-glance/utah-counties"
                    className="inline-flex items-center justify-center gap-2 rounded-full border border-white/25 bg-white/10 px-6 py-3 text-sm font-semibold text-white no-underline transition hover:bg-white/15"
                  >
                    Explore Utah Counties
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
